import {NaturalReferencingKeywordDataArray, useNaturalReferencing} from '../../../../../app/@types'
import React, {FC, useState} from 'react'
import {Headers, SortKeys, SortOrder} from '../types'
import {usePaginatedData, useSearchedData, useSortedData} from '../../../../../app/features'
import {Search} from '../../../content/forms'
import {THead} from '../components/THead'
import CountUp from 'react-countup'
import {Pagination} from '../../../content/pagination/Pagination'

const headers: Headers<NaturalReferencingKeywordDataArray>[] = [
    {key: 'date', label: 'Date', className: 'fw-bolder text-muted bg-light min-w-30px'},
    {key: 'clicks', label: 'Clics', className: 'fw-bolder text-muted bg-light min-w-20px'},
    {key: 'impressions', label: 'Impressions', className: 'fw-bolder text-muted bg-light min-w-20px'},
    {key: 'ctr', label: 'Ctr', className: 'fw-bolder text-muted bg-light min-w-20px'},
    {key: 'position', label: 'Position', className: 'fw-bolder text-muted bg-light min-w-20px'},
]

type Props = {
    data: NaturalReferencingKeywordDataArray[]
}
const TablesWidget29: FC<Props> = ({data}) => {

    const [sortKey, setSortKey] = useState<SortKeys<NaturalReferencingKeywordDataArray>>('date')
    const [sortOrder, setSortOrder] = useState<SortOrder>('desc')
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)

    const dataSorted: NaturalReferencingKeywordDataArray[] = useSortedData({
        data, sortKey, reverse: sortOrder === 'desc',
    })

    const {searchedData, setSearchQuery} = useSearchedData<NaturalReferencingKeywordDataArray>({
        data: dataSorted,
    })

    const paginatedData = usePaginatedData<NaturalReferencingKeywordDataArray>({
        currentPage, itemsPerPage, data: searchedData,
    })

    return (
        <>

            <div className="row mb-6">
                <div className="col-12">
                    <Search setSearchInput={setSearchQuery} />
                </div>
            </div>

            <div className="table-responsive">
                <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                    <THead headers={headers}
                           sortKey={sortKey}
                           setSortKey={setSortKey}
                           sortOrder={sortOrder}
                           setSortOrder={setSortOrder}
                    />
                    <tbody>
                    {
                        paginatedData.map((item, index) => (
                            <tr key={index}>
                                <td>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <span>{item.date}</span>
                                    </div>
                                </td>
                                <td>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <div className="badge badge-light-info fs-7">
                                            <CountUp end={+item.clicks} duration={.7} />
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <div className="badge badge-light-info fs-7">
                                            <CountUp end={+item.impressions} duration={.7} />
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <div className="badge badge-light-info fs-7">
                                            <CountUp end={+item.ctr} duration={.7} />
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <div className="badge badge-light-info fs-7">
                                            <CountUp end={+item.position} duration={.7} />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                    </tbody>
                </table>
            </div>
            <Pagination itemsPerPage={itemsPerPage}
                        totalItems={data.length}
                        setCurrentPage={setCurrentPage}
                        setItemsPerPage={setItemsPerPage}
            />

        </>
    )
}

export {TablesWidget29}